let allowTracking = true;

export function setAllowTracking(isAllowed: boolean) {
  allowTracking = isAllowed;
}

export function getAllowTracking() {
  return allowTracking;
}
